import useSWR from 'swr'
import {useToken} from "../../../../app/hooks";
import API from "../../../../utils/api";
import {useEffect} from "react";

interface ResponseTypes {
	list: any[];
	total: number;
}

const M_KEY = '/admin/settlement' // 광고목록 조회

const fetchKey = (page, maxData, searchWord, searchType, status) =>
	`${M_KEY}?${page && 'page=' + page}${maxData && '&maxData=' + maxData}${searchWord && '&searchWord=' + searchWord}${searchType && '&searchType=' + searchType}${status && '&status=' + status}`;

export function useAdminRefundList(page, maxData, searchWord, searchType,status) {
	const { data: token } = useToken();

	const KEY = fetchKey(page, maxData, searchWord, searchType, status);


	const fetcher = () => fetchAPI(KEY, token);
	const { data, mutate, isLoading } = useSWR(token ? `${KEY}` : null, fetcher, { revalidateOnFocus: true });

	return { adminRefundList: data?.list, mutateAdminRefundList: mutate, total: data?.total, isLoading };
}

async function fetchAPI(KEY:string, token:any): Promise<ResponseTypes> {
	try {
		const response = await API.get(`${KEY}`, token + '', {});
		return {list: response.result?.result?.list || [], total: response.result?.result?.totalCount}
	} catch (error) {
		console.error('Failed to fetch Admin Refund List:', error);
		return { list: [], total: 0 };
	}
}